export default __webpack_public_path__ + "static/media/cancelled.410a8840.svg";